import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';
import {
    HarvestEventForecastedQuantity,
    HarvestEventsProps
} from 'services/harvestEvents/types';

// Global Selectors
import { makeSelectHarvestEventForecastedQuantity } from 'services/harvestEvents/selectors';

type OwnProps = HarvestEventsProps;

interface ConnectedProps {
    forecastedQuantity?: HarvestEventForecastedQuantity;
}

type Props = OwnProps & ConnectedProps;

export class HarvestEventForecastedQuantityValue extends React.PureComponent<
    Props
> {
    render(): number | null {
        const { forecastedQuantity } = this.props;
        if (!forecastedQuantity) {
            return null;
        }
        return forecastedQuantity;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    forecastedQuantity: makeSelectHarvestEventForecastedQuantity()
});

export default connect(mapStateToProps)(HarvestEventForecastedQuantityValue);
